import React from 'react';
import ManageMessage from './ManageMessage';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs';
import { useHistory, useParams } from 'react-router-dom';
 

const ManageMessaging = () => {
    const route = '/manageMessaging'
    
    const history = useHistory();
    const { type } = useParams();
    const tabs = [{ name: 'Admin', type: 'Admin' },
        { name: 'Supplier', type: 'Supplier' },
        { name: 'Client', type: 'Client' },
        { name: 'User', type: 'User' },
       ]
    const setActiveTab = (tab) => {
        history.push(route + '/' + tab);
    }
    return <React.Fragment>
        <Tabs mountOnEnter={true} defaultActiveKey={type} onSelect={setActiveTab} >
            {
                tabs.map(tab => {
                    return <Tab key={tab.name} eventKey={tab.name} title={tab.name}  >
                        {tab.name === type ? <ManageMessage route={route} type={tab.type} />:null}
                    </Tab>
                })

            }
           
        </Tabs>
        
    </React.Fragment>

}
export default ManageMessaging;

